module.exports = __webpack_public_path__ + "img/back.8a73309e.png";